import '../headerfooter/headerfootercss.css';
import { Link } from 'react-router-dom';

function AccountHeader() {

  return (
    <>
      <div className='row col-12'>
        <ul className="nav nav-pills col-12" id="pills-tab" role="tablist">
          <Link className="navbar-item inwordbtn" to="/account" >Account </Link>
          <Link className="navbar-item inwordbtn" to="/productlist" > Vender Contract </Link>        
        </ul>
      </div>
    </>

  );
}
 export default AccountHeader;